var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60002 7.00039C1.60002 4.01805 4.01769 1.60039 7.00002 1.60039C9.98236 1.60039 12.4 4.01805 12.4 7.00039C12.4 9.98273 9.98236 12.4004 7.00002 12.4004C4.01769 12.4004 1.60002 9.98273 1.60002 7.00039ZM7.00002 0.400391C3.35494 0.400391 0.400024 3.35531 0.400024 7.00039C0.400024 10.6455 3.35494 13.6004 7.00002 13.6004C10.6451 13.6004 13.6 10.6455 13.6 7.00039C13.6 3.35531 10.6451 0.400391 7.00002 0.400391ZM7.39995 3.6C7.39995 3.26863 7.13132 3 6.79995 3C6.46858 3 6.19995 3.26863 6.19995 3.6V7.2C6.19995 7.42726 6.32835 7.63502 6.53162 7.73666L8.93162 8.93666C9.22801 9.08485 9.58841 8.96472 9.73661 8.66833C9.8848 8.37194 9.76467 8.01154 9.46828 7.86334L7.39995 6.82918V3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.eb6a505815907d7fea1f6f3a03afb8bc.svg";
export { ForwardRef as ReactComponent };